// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1jLTt","productName":"Table_productName__2awqZ"};